import { emit } from './emitter';
import { initClickObserver } from './clickObserver';
import { initViewObserver } from './viewObserver';
import type { FirstSessionGlobal } from './types';

const flushQueue = (): void => {
  const queue = window.firstSession?.q;
  if (!queue) return;

  queue.forEach(([eventName, properties, options]) => {
    emit(eventName, properties, options);
  });
};

const init = (): void => {
  if (window.firstSession?._initialized) return;

  // Flush any events queued before script loaded
  flushQueue();

  // Replace the stub with the initialized API
  const firstSession: FirstSessionGlobal = {
    trackEvent: emit,
    _initialized: true,
  };
  window.firstSession = firstSession;

  initClickObserver();
  initViewObserver();
};

// Boot when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
